import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing(3),
  },
}));

class RadioElements extends Component {

  constructor(props) {
    super(props);
    this.state = {
      checkArr: [],
      value: '',
    };
  }


  componentDidUpdate(prevProps) {
    if (prevProps.values != this.props.values) {
      this.setState({value: this.props.values})
      if(this.props.type == 'parent'){
        this.props.handleChangeRadio(this.props.values)
      }
    }
  }

  handleChangeRadio = (event, isInputChecked) => {
    var values = parseInt(event.target.value)
    this.setState({ value: event.target.value })
    if(this.props.type == 'parent'){
      this.props.handleChangeRadio(event.target.value)
    }
  }

  render() {
    var element = this.props.element;
    var radiobuttons = [];
    let options = Object.keys(element.optionMap);
    options.map((o, i) => {
      radiobuttons.push(
        <FormControlLabel
          key={i}
          id={i}
          name={this.props.name}
          value={o}
          control={<Radio name={this.props.name} />}
          label={element.optionMap[o]}
          onChange={this.handleChangeRadio}
        />
      );
    });

    return <RadioGroup name={element.name} value={this.state.value}>{radiobuttons}</RadioGroup>;
  }
}

export default RadioElements;
